<template>
  <div>
    <head-top></head-top>
    <el-row style="margin-top: 20px;" v-loading="loading">
      <el-col :span="20">
        <el-form :model="formData"  ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="课程名称" prop="name" >
            <el-input v-model="formData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="课程封面" prop="img">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='handlesuccess'
              :before-upload="beforeUploadimg"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:1}"
              :on-exceed="handleExceed">
              <div slot="tip" class="el-upload__tip">请上传206×206的jpg/png图片，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="视频封面" prop="img">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='videoImgsuccess'
              :before-upload="beforeUploadimg"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:1}"
              :on-exceed="handleExceed">
              <div slot="tip" class="el-upload__tip">请上传688×326的jpg/png图片，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="视频附件" prop="vio">
            <el-upload
              id="videoplayer"
              class="upload-demo"
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success="handleVideoSuccess"
              :before-upload="beforeUploadVideo"
              :headers="myHeaders"
              multiple
              :limit="1"
              :data = "{type:2}"
              :on-exceed="handleExceeds">
              <el-button size="small" type="primary">点击上传</el-button>
              <video :src="dialogVideotime"  id="viderplayer" style="display: none"></video>
            </el-upload>
          </el-form-item>
          <!--图文教程-->
          <el-form-item label="简介">
            <el-button size="small" type="primary"  @click="dialogFormVisible4 = true">添加教程</el-button>

          </el-form-item>
          <el-table
            :data="tablesData"
            style="width: 100%;margin-left:60px;">
            <el-table-column
              type="index"
              label="序号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="description"
              label="描述"
              width="180">
            </el-table-column>
            <el-table-column
              prop="imageUrl"
              label="图片地址">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="Viewmaterials(scope.$index, scope.row)">查看</el-button>
                <!--<el-button size="mini" type="text" @click="Editmaterial(scope.$index, scope.row)">编辑</el-button>-->
                <el-button size="mini" type="text" @click="handleDeletes(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 新增作品 -->
          <el-form-item label="作品赏析">
            <el-button size="small" type="primary"  @click="dialogFormVisible = true">添加作品</el-button>

          </el-form-item>
          <el-table
            :data="tableData"
            style="width: 100%;margin-left:60px;">
            <el-table-column
              type="index"
              label="序号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="studentName"
              label="学生姓名"
              width="180">
            </el-table-column>
            <el-table-column
              prop="worksUrl"
              label="作品地址">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="Viewmaterial(scope.$index, scope.row)">查看</el-button>
                <!--<el-button size="mini" type="text" @click="Editmaterial(scope.$index, scope.row)">编辑</el-button>-->
                <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!--添加学生作品-->
          <el-dialog title="添加作品" :visible.sync="dialogFormVisible">
            <el-form>
              <el-form-item label="学生姓名" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off" maxlength = "6"></el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='handlessuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="form.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <div slot="tip" class="el-upload__tip">请上传688×326的jpg/png图片，且不超过500kb</div>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel1">取 消</el-button>
              <el-button type="primary" @click="Addworks()">确 定</el-button>
            </div>
          </el-dialog>
          <!--查看-->
          <el-dialog title="查看作品" :visible.sync="dialogFormVisible2">
            <el-form>
              <el-form-item label="描述" width="300px">
                <span>{{addForm.name}}</span>
              </el-form-item>
              <el-form-item label="图片附件" class="mar" >
                <img v-bind:src="addForm.img">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible2 = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible2 = false">确 定</el-button>
            </div>
          </el-dialog>
          <!--编辑-->
          <el-dialog title="编辑作品" :visible.sync="dialogFormVisible3">
            <el-form>
              <el-form-item label="学生姓名" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off" maxlength = "6" ></el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='handlessuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="form.img"
                  :limit="1"
                  :data = "{type:1}">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="图片附件:" prop="img" :label-width="formLabelWidth">
                <img v-bind:src="addForm.img" style="width: 80%">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible3 = false">取 消</el-button>
              <el-button type="primary" @click="addSubmit()">确 定</el-button>
            </div>
          </el-dialog>
          <!--添加图文教程-->
          <el-dialog title="添加教程" :visible.sync="dialogFormVisible4">
            <el-form>
              <el-form-item label="描述" :label-width="formLabelWidth">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="Godaddy.name">
                </el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='Godaddysuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="Godaddy.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <div slot="tip" class="el-upload__tip">请上传688×326的jpg/png图片，且不超过500kb</div>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel2">取 消</el-button>
              <el-button type="primary" @click="Godaddys()">确 定</el-button>
            </div>
          </el-dialog>
          <!--查看图文教程-->
          <el-dialog title="查看教程" :visible.sync="dialogFormVisible5">
            <el-form >
              <el-form-item label="描述" width="300px">
                <span>{{Godaddy.name}}</span>
              </el-form-item>
              <el-form-item label="图片附件" class="mar" >
                <img v-bind:src="Godaddy.img" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" >
              <el-button @click="dialogFormVisible5 = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible5 = false">确 定</el-button>
            </div>
          </el-dialog>
          <!--修改图文教程-->
          <el-dialog title="编辑教程" :visible.sync="dialogFormVisible6">
            <el-form>
              <el-form-item label="课程描述" :label-width="formLabelWidth">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="Godaddy.name">
                </el-input>
              </el-form-item>
              <el-form-item label="图片附件" :label-width="formLabelWidth" class="mar">
                <el-upload
                  action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
                  :on-remove="handleRemove"
                  :on-success='Godaddysuccess'
                  :before-upload="beforeUploadimg"
                  :headers="myHeaders"
                  multiple
                  v-model="Godaddy.img"
                  :file-list="fileList"
                  :limit="1"
                  :data = "{type:1}">
                  <div slot="tip" class="el-upload__tip">请上传688×326的jpg/png图片，且不超过500kb</div>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="图片附件:" prop="img" :label-width="formLabelWidth">
                <img v-bind:src="Godaddy.img" style="width: 80%">
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible4 = false">取 消</el-button>
              <el-button type="primary" @click="Godaddysubmit()">确 定</el-button>
            </div>
          </el-dialog>
          <div class="but_bot">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import { getNewcourses } from '../api/api'
  export default {
    inject: ['reload'],
    data(){
      return {
        tableData: [],
        tablesData: [],
        fileList:[],
        currentPage:1,
        limit:20,
        formData: {
          name: '', //课程名称
          vio:"",//视频
          img:"",//封面
          tutorial:"",//教程
          newworks:"",//新增作品
        },
        dialogFormVisible: false,
        dialogFormVisible2: false,
        dialogFormVisible3: false,
        dialogFormVisible4: false,
        dialogFormVisible5: false,
        dialogFormVisible6: false,
        form: {
          name: '',
          img:''
        },
        Godaddy:{
          name:'',
          img:''
        },
        formLabelWidth: '80px',
        videoUrl:'',
        addForm:{},
        cover:'', //课程封面
        inde:0,
        videoImage:'',
        dialogVideotime:'',
        timeLength:'',
        myHeaders: {token: sessionStorage.token},
        loading:false
      }
    },
    components: {
      headTop
    },
    methods:{
      //上传课程封面
      handlesuccess(response, file, fileList){
        if(file.response.state == true){
          this.cover = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      Godaddysuccess(response, file, fileList){
        if(file.response.state == true){
          this.Godaddy.img = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      videoImgsuccess(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.videoImage = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      handlessuccess(response, file, fileList){
        //response即为后台返回的全部内容
        if(file.response.state == true){
          this.form.img = file.response.url
        }else{
          this.$message.error('图片上传失败');
        }
      },
      handleExceed(files, fileList) {
        this.$message.warning(`最多上传一张封面`);
      },
      handleExceeds(files, fileList) {
        this.$message.warning(`最多上传一个视频`);
      },
      handleRemove(file, fileList) {
        this.form.img = ''
        this.Godaddy.img = ''
      },
      beforeUploadVideo(file) {
        if (['video/mp4', 'video/ogg', 'video/flv','video/avi','video/wmv','video/rmvb'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的视频格式');
          return false
        }
      },
      beforeUploadimg(file) {
        if (['image/jpg', 'image/png', 'image/jpeg', 'image/gif'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的图片格式');
          return false
        }
      },
      handleVideoSuccess(response, file, fileList){
        if(file.response.state == true){
          this.videoUrl = file.response.url
          this.dialogVideotime = file.response.playUrl
        }else{
          this.$message.error('视频上传失败');
        }
      },
      //图文教程添加
      Godaddys(){
        if(this.Godaddy.name == '' || this.Godaddy.img == ''){
          this.$message({
            type: 'error',
            message: '请上传完整信息'
          });
        } else {
          const tablesData = {}
          tablesData.sort = (this.inde)++
          tablesData.description = this.Godaddy.name.replace(/ /g, "/t");
          tablesData.imageUrl = this.Godaddy.img;
          this.tablesData.push(tablesData);
          this.Godaddy = {
            name:'',
            img:''
          }
          this.fileList = [],
            this.dialogFormVisible4 = false
        }
      },
      //学生作品添加
      Addworks(date){
        if(this.form.name == '' || this.form.img == ''){
          this.$message({
            type: 'error',
            message: '请上传完整信息'
          });
        } else {
          const tableData = {};
          tableData.studentName = this.form.name;
          tableData.operateId = 1001;
          tableData.worksUrl = this.form.img;
          this.tableData.push(tableData);
          this.form = {
            name: '',
            img: ''
          },
            this.fileList = [],
            this.dialogFormVisible = false
        }
      },
      cancel1(){
        this.form = {
          name: '',
          img:''
        },
        this.fileList = []
        this.dialogFormVisible = false
      },
      cancel2(){
        this.Godaddy = {
          name:'',
          img:''
        }
        this.fileList = [],
        this.dialogFormVisible4 = false
      },
      //提交
      submit(){
        this.loading = true
        let params = {
          courseName:this.formData.name,
          timeLength:parseInt(document.getElementById('viderplayer').duration).toFixed(0),
          videoUrl:this.videoUrl,
          imageUrl:this.cover,
          category:3,
          videoImage:this.videoImage,
          text:JSON.stringify(this.tablesData),
          operationId:JSON.parse(sessionStorage.getItem('user')).id,
          works:JSON.stringify(this.tableData)
        }
        getNewcourses(params).then((res)=>{
          if (res.state == true) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.loading = false
            this.reload()
          }else{
            this.$message({
              type: 'error',
              message: '请上传正确信息'
            });
            this.loading = false
          }
        }).catch(error=>{
          this.loading = false
          console.log(error)
        })
      },
      //取消
      cancel(){
        this.reload()
        this.$router.push('course')
      },
      handleDelete(index,row){
        //  删除学生作品
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          this.tableData.splice(index, 1);
        }).catch(() => {
        })
      },
      Viewmaterials(index,row){
        //  查看图文教程
        this.dialogFormVisible5 = true
        this.Godaddy.name = row.description,
        this.Godaddy.img = row.imageUrl
      },
      //  删除图文教程
      handleDeletes(index,row){
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          this.tablesData.splice(index, 1);
        }).catch(() => {
        })
      },
      Viewmaterial(index,row){
        //  查看学生作品
        this.dialogFormVisible2 = true
        this.addForm.name = row.studentName,
        this.addForm.img = row.worksUrl
      },
      Editmaterial(index,row){
        //  编辑学生作品
        this.dialogFormVisible3 = true
        this.form.name = row.studentName
        this.addForm.img = row.worksUrl
      },
      addSubmit(index,row){
        const tableDatas={};
        tableDatas.studentName = this.form.name;
        tableDatas.worksUrl = this.form.img;
        this.tableData.splice(index, 1)
        this.tableData.push(tableDatas);
        this.form = {
          name: '',
          img:''
        },
        this.fileList = [],
        this.dialogFormVisible3 = false
      },
      Editmaterials(index,row){
        //  编辑图文教程
        this.dialogFormVisible6 = true
        this.Godaddy.name = row.description
        this.Godaddy.img = row.imageUrl
        this.Godaddy.sort = row.sort
      },
      Godaddysubmit(index,row){
        const tablesDatas={}
        tablesDatas.sort = (this.inde)++
        tablesDatas.description = this.Godaddy.name.replace(/ /g, "/t");
        tablesDatas.imageUrl = this.Godaddy.img;
        this.tablesData.splice(index, 1)
        this.tablesData.push(tablesDatas);
        this.Godaddy = {
          name:'',
          img:''
        }
        this.fileList = [],
        this.dialogFormVisible6 = false
      },
    },
    computed: {
    },
    created () {
    },

  }
</script>
<style>
  .edit_container{
    padding: 40px;
    margin-bottom: 40px;
  }
  .editer{
    height: 300px;
  }
  .mar{
    margin-top:20px;
  }
  .upload-demo{
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/page/newCourse.vue